import { of, Subject } from 'rxjs';
import { StoreLoader } from '@core-lib/classes/store-loader.class';
import { Unsubscriber } from '@core-lib/classes/unsubscriber.class';
export class HasLoader extends Unsubscriber {
	loading: boolean = false;
	loader: StoreLoader = new StoreLoader(of(false), of(null));
	loaderSubject = new Subject<StoreLoader>();
	loader$ = this.loaderSubject.asObservable();

	constructor() {
		super();
		this.loader$.subscribe(res => (this.loader = res));
	}

	/**
	 * Lancer le chargement
	 */
	startLoading(): void {
		this.loading = true;
		this.loaderSubject.next(new StoreLoader(of(this.loading), of(null)));
	}

	/**
	 * Arrêter le chargement
	 * @param error : Erreur de charegement, s'il y'a une
	 */
	stopLoading(error?: any): void {
		this.loading = false;
		this.loaderSubject.next(new StoreLoader(of(this.loading), of(error)));
	}
}
